import { BaseSAGOVElement } from '../sagov-base-component';
import html from 'raw-loader!./template.html';

export class SaGovNoteContainer extends BaseSAGOVElement {
  constructor() {
    super(html);
  }

  static get observedAttributes() {
    return ['label', 'date'];
  }

  connectedCallback() {
    // Update content when element is connected to DOM
    this.updateLabel();
    this.updateDate();
  }

  attributeChangedCallback(attributeName, oldValue, newValue) {
    if (this.debug) {
      console.log(`changing attribute ${attributeName} from ${oldValue} to ${newValue}`);
    }
    // Only update if shadowRoot is ready
    if (!this.shadowRoot) {
      return;
    }
    if (attributeName === 'label') {
      this.updateLabel();
    } else if (attributeName === 'date') {
      this.updateDate();
    }
  }

  updateLabel() {
    if (!this.shadowRoot) {
      return;
    }
    let labelElement = this.shadowRoot.querySelector('#textHolder');
    if (labelElement) {
      labelElement.innerHTML = `${this.label}`;
    }
  }

  get label() {
    return this._label || this.getAttribute('label') || '';
  }

  set label(value) {
    this._label = value;
    if (value !== null && value !== undefined) {
      this.setAttribute('label', value);
    }
    this.updateLabel();
  }

  updateDate() {
    if (!this.shadowRoot) {
      return;
    }
    let dateElement = this.shadowRoot.querySelector('#dateHolder');
    if (dateElement) {
      dateElement.innerHTML = `${this.date}`;
    }
  }

  get date() {
    return this._date || this.getAttribute('date') || '';
  }

  set date(value) {
    this._date = value;
    if (value !== null && value !== undefined) {
      this.setAttribute('date', value);
    }
    this.updateDate();
  }

  // if debug is set as an
  get debug() {
    return this.getAttribute('debug') === 'true';
  }
}

// eslint-disable-next-line no-undef
if (customElements.get('sagov-note-container') === undefined) {
  // eslint-disable-next-line no-undef
  window.customElements.define('sagov-note-container', SaGovNoteContainer);
}
